import React, { useEffect, useState } from "react";
import TableComponent from "../../../components/Table/TableComponent";
import APICall, {
  explodeDataWithRowTable,
} from "../../../components/Api/APICall";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import CommunEditModal from "../../../components/Modal/CommunEditModal";
import { InputBoxInput } from "./../../../components/Form/FormInputs";
import { TableCellAmountFormate } from "./../../CommanApiFunction";

export default function OrdersPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [InpValue, setInpValue] = useState({
    sdate: dayjs().format("YYYY-MM-DD"),
    edate: dayjs().format("YYYY-MM-DD"),
    cid: 0,
  });
  const [DataList, setDataList] = useState({
    row: [],
    dataWithRows: [],
    onlyData: [],
  });

  const [showModal, setShowModal] = useState(false);
  const [ModalData, setModalData] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
  /**
 * 
 {"status":true,"message":[{"id":1,"customer_id":"1","invoice_id":20230318192636,"payment_mode":"Cash","total":210,"recived_amount":10,"adddate":"2023-03-17T18:30:00.000Z","date_time":"2023-03-18T08:26:42.000Z","name":"हरेंद्र सिंह नेगी","contact":"9557735224","shop_name":"my store","location":"कोट"}]}
 */

  const tableHenders = [
    {
      accessor: "invoice_id",
      Header: "Invoice",
      Cell: (row) => TableCellAmountFormate(row, "text-green-600", false),
    },
    {
      accessor: "total",
      Header: "Total(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-orange-400"),
    },
    {
      accessor: "udhar",
      Header: "Udhar(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-red-800"),
    },
    {
      accessor: "recived_amount",
      Header: "RecivedAmount(₹)",
      Cell: (row) => TableCellAmountFormate(row, "text-green-900"),
    },
    {
      accessor: "name",
      Header: "CustomerName",
    },
    {
      accessor: "contact",
      Header: "contact",
    },
    {
      accessor: "payment_mode",
      Header: "PaymentMode",
    },
    {
      accessor: "shop_name",
      Header: "ShopName",
    },
    {
      accessor: "location",
      Header: "Location",
    },
    {
      accessor: "adddate",
      Header: "Date",
    },
    {
      accessor: "other",
      Header: "Others Data",
    },
  ];

  const OtherItemViewHandler = (invoiceid) => {
    setTotalAmount(0);
    APICall(`/service/orderlist?invoiceid=${invoiceid}`).then((data) => {
      if (data.status) {
        setModalData(data.message);
        setTotalAmount(
          data.message
            .map((item) => parseInt(item.amount) * parseInt(item.quantity))
            .reduce((sum, item) => sum + item)
        );
        setShowModal(true);
      }
    });
  };
  const DataListAPiCall = (sdate, edate, cid) => {
    cid = cid === "" ? 0 : cid;
    APICall(`/service/invoices?sdate=${sdate}&edate=${edate}&cid=${cid}`).then(
      (data) => {
        if (data.status) {
          let newData = [];
          if (data.message.length > 0) {
            newData = data.message.map((item) => ({
              ...item,
              udhar: item.recived_amount - item.total,
              adddate: dayjs(item.adddate).format("DD-MM-YYYY"),
              other: (
                <button
                  onClick={() => OtherItemViewHandler(item.invoice_id)}
                  className="bg-blue-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                >
                  View
                </button>
              ),
            }));
          }
          setIsLoading(false);
          explodeDataWithRowTable(newData, setDataList);
        } else {
          setIsLoading(false);
          toast.error(data.message);
        }
      }
    );
  };
  useEffect(() => {
    const { sdate, edate, cid } = InpValue;
    DataListAPiCall(sdate, edate, cid);
  }, []);
  const inputChangeHandler = (event) => {
    const { name, value } = event.target;
    setInpValue((v) => ({ ...v, [name]: value }));
  };
  const SearchReportHandler = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const { sdate, edate, cid } = InpValue;
    DataListAPiCall(sdate, edate, cid);
  };
  return (
    <>
      <div className="relative  flex flex-col min-w-0 break-words bg-white w-full mb-1 pb-5 shadow-lg rounded">
        <form method="post" onSubmit={SearchReportHandler}>
          <div className="px-5 grid grid-cols-2 gap-2 md:grid-cols-6">
            <div>
              <InputBoxInput
                label="consumer Name"
                data={{
                  id: "cid",
                  name: "cid",
                  value: InpValue.cid === 0 ? "" : InpValue.cid,
                  type: "text",
                  placeholder: "Consumer Name",
                }}
                inputChangeHandler={inputChangeHandler}
              />
            </div>

            <div>
              <InputBoxInput
                label="Start Date"
                data={{
                  id: "startDate",
                  name: "sdate",
                  value: InpValue.sdate,
                  type: "date",
                  required: "required",
                }}
                inputChangeHandler={inputChangeHandler}
              />
            </div>
            <div>
              <InputBoxInput
                label="End Date"
                data={{
                  id: "edate",
                  name: "edate",
                  value: InpValue.edate,
                  type: "date",
                  required: "required",
                }}
                inputChangeHandler={inputChangeHandler}
              />
            </div>
            <div className="text-center items-center md:pt-7">
              {isLoading ? (
                <button
                  type="button"
                  disabled
                  className=" bg-green-500 mt-3 text-white active:bg-indigo-600 text-xs font-bold uppercase px-5 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                >
                  <i className="animate-spin fas fa-spinner  pr-3"></i>
                  Loading...
                </button>
              ) : (
                <button
                  type="submit"
                  className="bg-green-500 mt-3 text-white active:bg-indigo-600 text-xs font-bold uppercase px-5 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                >
                  <i className="fas fa-paper-plane pr-3"></i> Search Report
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <TableComponent
          columns={tableHenders}
          data={DataList.dataWithRows}
          selectOption={{ show: false }}
          pagination={true}
          exportData={true}
          TicketsTitle={`Orders View`}
        />
        <CommunEditModal
          showModal={showModal}
          setShowModal={setShowModal}
          Title="Order List"
        >
            <div className="overflow-x-auto">
              <table className="text-center mb-5">
                <thead className="border-b bg-gray-800">
                  <tr>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      #
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      Invoice
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      Product name
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      Product Price
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      Quantity
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-white px-6 py-2"
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ModalData.map((item, i) => (
                    <tr className="bg-white border-b" key={`item_${i}`}>
                      <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                        {i + 1}
                      </td>
                      <td className="text-sm text-gray-900  px-6 py-2 whitespace-nowrap">
                        {item.invoice_id}
                      </td>
                      <td className="text-sm text-gray-900  px-6 py-2 whitespace-nowrap">
                        {item.service_name}
                      </td>
                      <td className="text-sm text-gray-900  px-6 py-2 whitespace-nowrap">
                        ₹{parseInt(item.amount).toFixed(2)}
                      </td>
                      <td className="text-sm text-gray-900  px-6 py-2 whitespace-nowrap">
                        {item.quantity}
                      </td>
                      <td className="text-sm text-gray-900  px-6 py-2 whitespace-nowrap">
                        ₹
                        {(
                          parseInt(item.amount) * parseInt(item.quantity)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-white border-b">
                    <td
                      className="px-6 py-2 whitespace-nowrap text-sm font-extrabold text-gray-900 text-center"
                      colSpan={5}
                    >
                      Total
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm font-extrabold  text-center text-green-500">
                      ₹ {TotalAmount.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </CommunEditModal>
      </div>
    </>
  );
}
